import axios from "axios";
import { API_URL } from "../../../utils/constants";

export const getAzureSitesApi = async (param, provider) => {
  try {
    param.params.type = 1;
    const token = localStorage.getItem('api_token');
    const endpoint = provider === "gcp" ? "gcp/storage-buckets" : "static-website-details";
    const response = await axios({
      method: "GET",
      url: `${API_URL}${endpoint}`,
      headers: {
        "Content-Type": "application/json",
        "Authorization": token ? `Bearer ${token}` : "", // Include token if available
      },
      data: param.params,
    });
    console.log(response, 'lllllll')
    return response;
  } catch (e) {
    return [];
  }
};
